export const BITCOIN = '#ff9900';
